import getFolderChangeDigestOperation from 'owa-service/lib/operation/getFolderChangeDigestOperation';
// Max number of senders to return
var MAX_SENDERS_COUNT = 10;
/**
 * Action to get focused inbox rollup data
 * @param folderId the target folder id
 * @param InboxViewType target view type
 * @param watermark indicates last visited timestamp for the view
 * @param isConversationView whether the folder is in conversation view
 * @return the GetFolderChangeDigestResponse
 */
export default function getFolderChangeDigestService(folderId, viewType, watermark, isConversationView) {
    var folderChangeDigest = {
        FolderId: folderId,
        IsConversationView: isConversationView,
        ViewType: viewType,
        Watermark: watermark,
    };
    var getFolderChangeDigestRequest = {
        Folders: [folderChangeDigest],
        MaxSendersCount: MAX_SENDERS_COUNT,
    };
    return getFolderChangeDigestOperation(getFolderChangeDigestRequest).then(function (response) {
        return response;
    });
}
//# sourceMappingURL=getFolderChangeDigestService.js.map